/* eslint-disable react/jsx-sort-props */

/**
 * DO NOT MODIFY THIS ICON DIRECTLY.
 *
 * THIS ICON WAS AUTOMATICALLY GENERATED.
 * SVG RETRIEVED FROM SPRING FOUNDATIONS FIGMA FILE.
 * @see https://www.figma.com/design/kcg95u086DD7Sa9or8Bwpq/%F0%9F%8C%B1--Foundations---Spring-2.0?node-id=24-2&p=f&t=75lUXy0FPOr0htKP-0
 */
import React from 'react';

import {Icon as BaseIcon, type BaseIconProps} from './Icon/Icon';
import {IconComponent} from './types';

export const AddPanelAddToCart64Icon = React.forwardRef<
  HTMLDivElement,
  BaseIconProps
>(({size = 64, ...props}, ref) => {
  return (
    <BaseIcon {...props} size={size} ref={ref}>
      <svg
        data-wf-icon="AddPanelAddToCart64Icon"
        width="64"
        height="64"
        viewBox="0 0 64 64"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g>
          <g>
            <path d="M41 29V30.2793L34 32.6123V29H41Z" fill="currentColor" />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M51 20C53.7614 20 56 22.2386 56 25V39C56 41.7614 53.7614 44 51 44H13C10.2386 44 8 41.7614 8 39V25C8 22.2386 10.2386 20 13 20H51ZM34 35C33.4477 35 33 35.4477 33 36C33 36.5523 33.4477 37 34 37C34.5523 37 35 36.5523 35 36C35 35.4477 34.5523 35 34 35ZM40 35C39.4477 35 39 35.4477 39 36C39 36.5523 39.4477 37 40 37C40.5523 37 41 36.5523 41 36C41 35.4477 40.5523 35 40 35ZM25 28V31H22V32H25V35H26V32H29V31H26V28H25ZM31 26V27H33V33.3066C33.0002 33.6477 33.3346 33.8882 33.6582 33.7803L41.6582 31.1143C41.8624 31.0462 42 30.8549 42 30.6396V28.5C42 28.2239 41.7761 28 41.5 28H34V27C34 26.4477 33.5523 26 33 26H31Z"
              fill="currentColor"
            />
          </g>
        </g>
      </svg>
    </BaseIcon>
  );
}) as IconComponent;

AddPanelAddToCart64Icon.tags = [
  'add',
  'cart',
  'shopping',
  'purchase',
  'ecommerce',
];

AddPanelAddToCart64Icon.category = '64x64 (Add panel)';

AddPanelAddToCart64Icon.iconSize = 64;
